import IconSvgDemo from './IconSvgDemo'

export default IconSvgDemo
// eslint-disable-next-line import/export
export * from './IconSvgDemo'
